import { useParams, useSearchParams } from "react-router-dom";
import { doc } from "firebase/firestore";
import { useFirestore, useFirestoreDocDataOnce, useFunctions } from "reactfire";
import Loading from "../components/LoadingComponent";
import ProgressBar from "../components/ProgressBar";
import AppInstall from "../components/AppInstall";
import { Icon } from "@iconify/react";
import playIcon from "@iconify/icons-ic/round-play-arrow";
import pauseIcon from "@iconify/icons-ic/round-pause";
import forward10sIcon from "@iconify/icons-ic/round-forward-10";
import replay10sIcon from "@iconify/icons-ic/round-replay-10";
import ReactPlayer from "react-player/file";
import { useEffect, useState } from "react";
import { formatTime } from "../utils/formatTime";
import { httpsCallable } from "firebase/functions";
import PlayerTips from "../components/PlayerTips";

const PodcastRabbiPage1 = () => {
  const { id, channelId } = useParams(); 
  const [searchParams, setSearchParams] = useSearchParams();
  const functions = useFunctions();
  let playerRef;
  const [playing, setPlaying] = useState(false);
  const [elapsed, setElapsed] = useState(0);
  const [played, setPlayed] = useState(0);
  const [duration, setDuration] = useState(0);

  const podcastRef = doc(
    useFirestore(),
    "app",
    "rabbi_channels",
    "channel_names",
    channelId, 
    "uploads_rabbi",
    id
  );

  const { status, data } = useFirestoreDocDataOnce(podcastRef);

  const handlePlayPause = () => {
    setPlaying(!playing);
  };

  const handleDuration = (d) => {
    setDuration(d);
  };

  const handlePlayed = (p) => {
    setPlayed(p);
  };

  const repeat10s = () => {
    playerRef.seekTo(elapsed - 10, "seconds");
  };

  const skip10s = () => {
    playerRef.seekTo(elapsed + 10, "seconds");
  };

  useEffect(() => {
    setTimeout(() => {
      callAddStatForAnonymousUser(id);
    }, 3000);
  }, [id]);

  const callAddStatForAnonymousUser = (id) => {
    const refBy = searchParams.get("referralBy");
    if (!refBy) return;

    const addReferralStatFromAnonymous = httpsCallable(
      functions,
      "addReferralStatFromAnonymous"
    );

    addReferralStatFromAnonymous({
      referralBy: refBy,
      podcastId: id,
    }).then((res) => {
      console.log(res);
    });
  };

  if (status === "loading") {
    return (
      <div className="h-screen w-full flex justify-center items-center">
        <Loading />
      </div>
    );
  } else if (status === "error") {
    return <div>Something went wrong...</div>;
  }

  const languages = navigator.languages || [];
  const language = languages.length > 0 ? languages[0] : "en";

  let coverArtEN = data.coverArt || "";
  let coverArtHE = data.coverArtHE || "";
  let coverArtRU = data.coverArtRU || "";
  let titleEN = data.title || "";
  let titleHE = data.titleHE || "";
  let titleRU = data.titleRU || "";
  let descriptionEN = data.description || "";
  let descriptionHE = data.descriptionHE || "";
  let descriptionRU = data.descriptionRU || "";

  let coverArt = coverArtEN;
  let title = titleEN;
  let description = descriptionEN;

  if (language.startsWith("he")) {
    coverArt = coverArtHE || coverArtEN;
    title = titleHE || titleEN;
    description = descriptionHE || descriptionEN;
  } else if (language.startsWith("ru")) {
    coverArt = coverArtRU || coverArtEN;
    title = titleRU || titleEN;
    description = descriptionRU || descriptionEN;
  }

  return (
    <div
      className="container mx-auto"
      dir={language.startsWith("he") ? "rtl" : "ltr"}
    >
      {/* app install banner */}
      <div className="mb-16 mt-0 sm:mt-4">
        <AppInstall />
      </div>
      {/* app install banner */}
      <div className="p-8">
        <div className="flex flex-col justify-center text-center sm:flex-row items-center space-x-4 md:space-y-0 space-y-4">
          <img
            src={coverArt}
            className="w-60 h-60 rounded-2xl shadow-lg bg-gray-100"
            alt="Podcast Cover"
          />
          <div className="min-w-0 space-y-2 font-semibold">
            <div className="font-bold text-2xl text-gray-800">{title}</div>
            <div className="text-gray-500">{description}</div>
          </div>
        </div>
        <ReactPlayer
          url={data.audioFile}
          ref={(r) => (playerRef = r)}
          playing={playing}
          loop
          onProgress={(p) => {
            handlePlayed(p.played);
            setElapsed(p.playedSeconds);
          }}
          onDuration={handleDuration}
          onError={(e) => {
            console.log(e);
          }}
          style={{ display: "none" }}
        />
        {/* progress bar */}
        <div className="mt-12">
          <ProgressBar
            duration={formatTime(duration)}
            elapsed={formatTime(elapsed)}
            progress={`${played * 100}%`}
          />
        </div>
        {/* progress bar */}
        {/* controls */}
        <div className="mt-12 mb-12">
          <div className="flex items-center justify-evenly">
            <button
              onClick={repeat10s}
              className="rounded-full text-gray-600 hover:bg-gray-200 p-2"
            >
              <Icon icon={replay10sIcon} className="w-12 h-12" />
            </button>
            <button
              onClick={handlePlayPause}
              className="rounded-full text-white bg-blue-600 hover:bg-blue-700 p-2"
            >
              <Icon icon={playing ? pauseIcon : playIcon} className="w-12 h-12" />
            </button>
            <button
              onClick={skip10s}
              className="rounded-full text-gray-600 hover:bg-gray-200 p-2"
            >
              <Icon icon={forward10sIcon} className="w-12 h-12" />
            </button>
          </div>
        </div>
        {/* controls */}
      </div>
      {/* bottom cta */}
      <div className="md:w-3/4 mx-auto md:rounded fixed bottom-0 left-0 right-0 bg-gray-200 p-4">
        <PlayerTips />
      </div>
      {/* bottom cta */}
    </div>
  );
};

export default PodcastRabbiPage1;
